window.dataLayer = window.dataLayer || [];
function trackEvent(eventName, element, extraData = {}) {
    let eventData = {
        'event': eventName,
        'referrer': document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
        'locale': document.documentElement.lang || "en",
        // 'elementText': element.innerText.trim() || element.placeholder || 'Unknown',
        // 'isUserLoggedIn': document.body.classList.contains("customer-logged-in"),      
        'device.category': navigator.userAgent.includes("Mobi") ? "mobile" : "desktop",
        'utm': new URLSearchParams(window.location.search).get("utm_source") || "direct",
        'timestamp': new Date().toISOString(),
        // 'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        // 'user_agent': navigator.userAgent,
        'gtm.uniqueEventId': new Date().getTime(),
        // 'gtm.uniqueEventId': window.dataLayer.length + 1,     
        ...extraData
    };
    window.dataLayer.push(eventData);
    // console.log("Event Pushed:", eventData);
}
//Search Click
document.addEventListener("click", function(event) {
    let searchInput = event.target.closest("input[data-predictive-search-input]");
    if (searchInput) {
        let searchQuery = searchInput.value.trim() || "N/A"; // Get Search Term
        let clickedResult = event.target.closest("a"); // Check if Clicked Element is a Link
        let clickDestination = clickedResult && clickedResult.href.includes("/products/") ? "product_page" : "search_results_page";
        let searchClickData = {
            'event': "SEARCH_CLICK",
            'referrer': document.referrer.includes("google") ? "google" : "meta",
            'locale': document.documentElement.lang || "en",
            'device.category': navigator.userAgent.includes("Mobi") ? "mobile" : "desktop",
            'utm': new URLSearchParams(window.location.search).get("utm_source") || "direct",
            'timestamp': new Date().toISOString(),
            'gtm.uniqueEventId': new Date().getTime(),
            'search_query': searchQuery,
            'click_destination': clickDestination
        };
        window.dataLayer.push(searchClickData);       
    }
});
// Collection Click
document.addEventListener("click", function(event) {
    let menuLink = event.target.closest("a[data-top-link]");  
    if (menuLink) {
      let collectionName = menuLink.innerText.trim() || "Unknown";
      let clickDestination = menuLink.href.includes("/collections/") ? "collection_page" : "other";
        trackEvent("MENU_CLICK", menuLink,{
          'collection_name': collectionName,
          'click_destination': clickDestination
        });
    }
});
// Cart Click
//   document.addEventListener("click", function(event) {
//     let cartBtn = event.target.closest("a[href*='/cart']");
//     if (cartBtn) {
//         let cartItemCount = document.querySelector("[data-cart-count]") ? 
//             parseInt(document.querySelector("[data-cart-count]").innerText, 10) || 0 : 0;
//         setTimeout(() => {
//             let cartValueElement = document.querySelector("[data-currency-usd], [data-amount], [ge-data-original-price]");
//             let rawCartValue = cartValueElement ? cartValueElement.getAttribute("data-currency-usd") || 
//                                                    cartValueElement.getAttribute("data-amount") || 
//                                                    cartValueElement.getAttribute("ge-data-original-price") || "0" : "0";
//             let numericCartValue = parseFloat(rawCartValue.replace(/[^0-9.]/g, "")) || 0.0;
//             let formattedCartValue = `$${Math.round(numericCartValue)}`;
//             trackEvent("CART_CLICK", cartBtn, {
//                 'cart_item_count': cartItemCount,
//                 'cart_discount': formattedCartValue,
//               'cart_total': numericCartValue
//             });           
//         }, 500);
//     }
// });
document.addEventListener("click", function(event) {
    let cartBtn = event.target.closest("a[href*='/cart']");
    if (cartBtn) {
        let cartItemCount = document.querySelector("[data-cart-count]") ? 
            parseInt(document.querySelector("[data-cart-count]").innerText, 10) || 0 : 0;

        setTimeout(() => {
            // Extract total cart value
            let totalPriceElement = document.querySelector(".cart__foot__inner .docapp-est-total .money"); // Adjust selector if needed
            let rawCartTotal = totalPriceElement ? totalPriceElement.innerText : "0";
            let numericCartTotal = parseFloat(rawCartTotal.replace(/[^0-9.]/g, "")) || 0.0;
          let formattedCartTotal = `$${numericCartTotal}`; // Add $ sign

            // Extract cart discount
            let discountElement = document.querySelector(".cart__foot__inner .docapp-cart-discount [data-currency-usd]"); // Adjust selector if needed
            let rawCartDiscount = discountElement ? discountElement.innerText : "0";
            let numericCartDiscount = parseFloat(rawCartDiscount.replace(/[^0-9.]/g, "")) || 0.0;
            let formattedCartDiscount = `$${numericCartDiscount}`; // Add $ sign
                
            trackEvent("CART_CLICK", cartBtn, {
              'event': 'CART_CLICK',
                            'cart_item_count': cartItemCount,
                            'cart_total': formattedCartTotal,
                            'cart_discount': formattedCartDiscount
            });
            }, 500);
            }
});
  
// Category Click
document.addEventListener("click", function(event) {
    let categoryBtn = event.target.closest("a.reel_inner");
    if (categoryBtn) {
        // console.log("Clicked Element:", categoryBtn); 
        trackEvent("CATEGORY_CLICK", categoryBtn, {
            'category_name': categoryBtn.textContent.trim()
        });      
        // console.log("Category Name:", categoryBtn.textContent.trim());
    }
});
 // Treand Click
document.addEventListener("click", function(event) {
  let trendSlide = event.target.closest(".swiper-slide.category_main_slide");
  if(trendSlide){
    let trendName = trendSlide.getAttribute("data-title") || "Unknown Trend";
    trackEvent("TREND_CLICK", trendSlide, {
            'trend_name': trendName
        });    
  }
});
 // Treand Click(tranding now section)
document.addEventListener("click", function(event) {
  let trendnowSlide = event.target.closest(".image_banner_main");
  if(trendnowSlide){
    let trendnowName = trendnowSlide.getAttribute("data-title") || "Unknown Trend";
    trackEvent("TREND_CLICK", trendnowSlide, {
            'trend_name': trendnowName
        });    
  }
});
// Delete icon click
document.addEventListener("click", function (event) {
    let deleteButton = event.target.closest(".cart__item__remove");
    if (deleteButton) {        
        trackEvent("DELETE_PRODUCT_CLICK", deleteButton, {         
        });
    }
});
// Quantity icon click
document.addEventListener("click", function (event) {
  let quantityButton = event.target.closest(".cart__quantity-minus,.cart__quantity-plus");
  if(quantityButton){
    trackEvent("CHANGE_QUANTITY_CLICK", quantityButton);
  }
});
//Share Click
document.addEventListener("click", function (event) {
  let shareBtn= event.target.closest(".sharing-button");
  if (shareBtn) {
    trackEvent("SHARE_CLICK", shareBtn);
  }
});
//Size Click
document.addEventListener("change", function(event) {
    let selectedSizeInput = event.target.closest('input[type="radio"][name^="options[Size]"]');    
    if (selectedSizeInput) {
        let label = document.querySelector(`label[for="${selectedSizeInput.id}"]`);
        let sizeValue = label ? label.querySelector('.variant_number')?.innerText.trim() : selectedSizeInput.value;        
        if (sizeValue) {
            setTimeout(() => {
                trackEvent("SIZE", selectedSizeInput, { 'size': sizeValue });
            }, 100);
        } 
    }
});
// Product Click
document.addEventListener("click", function (event) {
    let productElement = event.target.closest(".product-item");
    if (!productElement) return;
    let productLink = productElement.querySelector(".product-link");
    let productTitle = productElement.querySelector(".product-item__title span");
    let productCategory = productElement.querySelector(".subtitle");
    let productPrice = productElement.querySelector(".new-price");
    trackEvent("PRODUCT_CLICK", productElement, {
        'product_id': productElement.id ? productElement.id.split("--").pop() : "Unknown",
        'product_name': productTitle ? productTitle.innerText.trim() : "Unnamed Product",
        'product_category': productCategory ? productCategory.innerText.trim() : "Uncategorized",
        'product_price': productPrice ? parseFloat(productPrice.innerText.replace(/[^0-9.]/g, "")) : 0.0
    });
});
// add to cart Click
document.addEventListener("click", function (event) {
    let addToCartBtn = event.target.closest("button[data-add-to-cart]");
    if (!addToCartBtn) return;    
    let productElement = event.target.closest(".product__submit");
    if (!productElement) return;
    // Extract product details
    let productTitle = document.querySelector(".product__title__wrapper h1")?.innerText.trim() || "Unnamed Product";
    let productCategory = document.querySelector(".subtitle")?.innerText.trim() || "Uncategorized";
    let productPriceElement = document.querySelector(".product__price");
    let productPrice = productPriceElement ? parseFloat(productPriceElement.innerText.replace(/[^0-9.]/g, "")) : 0.0;    
    let quantityInput = document.querySelector(".quantity__input");
    let quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    setTimeout(() => {
        // Extract correct cart value
        let cartValueElement = document.querySelector("[data-cart-total], [data-cart-value], [data-amount], [ge-data-original-price]");
        let rawCartValue = cartValueElement ? cartValueElement.innerText.trim() || "0" : "0";
        let numericCartValue = parseFloat(rawCartValue.replace(/[^0-9.]/g, "")) || 0.0;
        let formattedCartValue = `$${Math.round(numericCartValue)}`;        
        let cartItemCount = document.querySelector("[data-cart-count]") ?
                            parseInt(document.querySelector("[data-cart-count]").innerText, 10) || 0 : 0;
        // Fire event with corrected cart value
        trackEvent("ADD_TO_CART_CLICK", addToCartBtn, {
            // 'product_id': productElement.id ? productElement.id.split("--").pop() : "Unknown",
            'product_name': productTitle,
            'product_category': productCategory,
            'product_price': productPrice,
            // 'cart_value': formattedCartValue,
            // 'cart_item_count': cartItemCount + quantity
        });
    }, 500);
});
// product detail click
document.addEventListener("click", function(event) {
  let accordionTitle = event.target.closest(".accordion__title");
  if (accordionTitle) {
    let detailSection = accordionTitle.querySelector(".accor-title")?.innerText.trim() || "Unknown";
    trackEvent("PRODUCT_DETAILS_CLICK", accordionTitle, {
            'detail_section': detailSection
        });
  }
});
// Profile Click
document.addEventListener("click", function(event) {
    let accountBtn = event.target.closest("a[href*='/account']");
    if (accountBtn) {
        trackEvent("account_click", accountBtn);
    }
});
//Share Click
document.addEventListener("click", function (event) {
  let shareBtn= event.target.closest(".sharing-button");
  if (shareBtn) {
    trackEvent("SHARE_CLICK", shareBtn);
  }
});
// Login Success Tracking
document.addEventListener("submit", function(event) {
    let loginForm = event.target.closest("form[action*='/account/login']");
    if (loginForm) {
        event.preventDefault(); // Prevent default to track the event first
        let emailInput = loginForm.querySelector("input[type='email']");
        let email = emailInput ? emailInput.value.trim() : "unknown";        
        trackEvent("LOGIN_SUCCESS", loginForm, {
            'email': email,
            'type': "email"
        });
        // console.log("Tracking LOGIN_SUCCESS:", { email: email, type: "email" });
        // alert("Tracking LOGIN_SUCCESS: " + JSON.stringify({ email: email, type: "email" }));
        setTimeout(() => loginForm.submit(), 500); // Delay login for smooth tracking
    }
});
// login Failure
document.addEventListener("submit", function(event) {
    let loginForm = event.target.closest("form[action*='/account/login']");
    if (loginForm) {
        event.preventDefault();         
        let emailInput = loginForm.querySelector("input[type='email']");
        let passwordInput = loginForm.querySelector("input[type='password']");
        let email = emailInput ? emailInput.value.trim() : "unknown";
        let password = passwordInput ? passwordInput.value.trim() : "";
        let attemptCount = parseInt(sessionStorage.getItem("login_attempts") || "0") + 1;
        sessionStorage.setItem("login_attempts", attemptCount);
        let reason = email === "" ? "wrong email" : password === "" ? "wrong password" : "invalid credentials";
        trackEvent("LOGIN_FAILURE", {
            'email': email,
            'type': "email",
            'reason': reason,
            'attempt_count': attemptCount
        });
        // console.log("Tracking LOGIN_FAILURE:", { email: email, reason: reason, attempt_count: attemptCount });
        // alert("LOGIN_FAILURE: " + JSON.stringify({ email: email, reason: reason, attempt_count: attemptCount }));
        setTimeout(() => loginForm.submit(), 500);
    }
});
// forgot password
document.addEventListener("submit", function(event) {
    let forgotPasswordForm = event.target.closest("form[action*='/account/recover']");
    if (forgotPasswordForm) {
        event.preventDefault(); // Prevent default submission for testing
        trackEvent("FORGOT_PASSWORD", {
            'reset_method': "email",
            'reset_status': "initiated"
        });
        // console.log("Tracking FORGOT_PASSWORD: { reset_method: 'email', reset_status: 'initiated' }");
        // alert("Tracking FORGOT_PASSWORD: Reset initiated");
        setTimeout(() => forgotPasswordForm.submit(), 500);
    }
});
//signup click
document.addEventListener("click", function(event) {
    let signupLink = event.target.closest("a[href='/account/register']");
    if (signupLink) {
        trackEvent("SIGNUP_CLICK", signupLink);
      // alert("signupLink:", signupLink);
    }
});  
// Track Signup Failures
document.addEventListener("submit", function(event) {
    let signupForm = event.target.closest("form[action*='/account/register']");
    if (signupForm) {
        setTimeout(() => {
            let errorElement = document.querySelector(".error-message"); // Adjust selector as needed
            if (errorElement) {
                let reason = errorElement.innerText.includes("email") ? "wrong email" :
                             errorElement.innerText.includes("password") ? "wrong password" : "other";
                let attemptCount = parseInt(localStorage.getItem("signup_attempts") || "0", 10) + 1;
                localStorage.setItem("signup_attempts", attemptCount);
                trackEvent("SIGNUP_FAILURE", {
                    'reason': reason,
                    'attempt_count': attemptCount
                });
            }
        }, 500);
    }
});

//signup success
document.addEventListener("submit", function(event) {
    let signupForm = event.target.closest("form[action*='/account/register']");
    if (signupForm) {
        let emailInput = signupForm.querySelector("input[type='email']");
        let userEmail = emailInput ? emailInput.value.trim() : "N/A";
        setTimeout(() => {
            if (window.location.pathname.includes("/account")) { 
                trackEvent("SIGNUP_SUCCESS", {
                    'email': userEmail,
                    'type': "email"
                });              
            }
        }, 1500); 
    }
});
// checkout click
document.addEventListener("click", function (event) {
    let checkoutButton = event.target.closest(".cart__buttons");
    if (checkoutButton) {
        let cartItemCount = document.querySelector("[data-cart-count]") ? 
            parseInt(document.querySelector("[data-cart-count]").innerText, 10) || 0 : 0;
        let cartValueElement = document.querySelector(".docapp-est-total [data-amount]");
        let cartValue = cartValueElement ? parseFloat(cartValueElement.getAttribute("data-amount") || "0") : 0;
        let couponApplied = document.querySelector(".docapp-coupon-input--bean-container--bean") ? "true" : "false";
        let couponCode = couponApplied === "true" ? document.querySelector(".docapp-coupon-input--bean-container--bean")?.textContent.trim() : "";
        // alert(
        //     `Checkout button clicked!\n` +
        //     `Cart Item Count: ${cartItemCount}\n` +
        //     `Cart Value: ${cartValue}\n` +
        //     `Coupon Applied: ${couponApplied}\n` +
        //     `Coupon Code: ${couponCode}`
        // );
        trackEvent("CHECKOUT_CLICK", checkoutButton, {
            cart_item_count: cartItemCount,
            cart_value: cartValue,
            coupon_applied: couponApplied,
            coupon_code: couponCode
        });      
    }
});

// discount coupon code 
document.addEventListener("click", function (event) {
  let couponnCode = event.target.closest(".docapp-coupon-input--button");
  if (couponnCode) {
    // alert("test");
  }
});

// fliter track
document.addEventListener("click", function(event) {
      const filterElement = event.target.closest(".popout--group");
      if (filterElement) {
        const filterLabel = filterElement.querySelector('.popout__toggle')?.innerText?.trim();
        trackEvent("FILTER_CLICK", filterElement, {
           filter_type: filterLabel || 'unknown'
        });
      }
    });

// sortby track
document.addEventListener("click", function(event) {
      const filterElement = event.target.closest(".popout--sort");
      if (filterElement) {
        const filterLabel = filterElement.querySelector('.popout__toggle')?.innerText?.trim();
        trackEvent("SORTBY_CLICK", filterElement, {
           filter_type: filterLabel || 'unknown'
        });
      }
    });
